export default "__VITE_ASSET__CpehY9Sc__"